'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lat_lng = {};

exports.__exports = lat_lng;
